import React, {useCallback} from 'react'
import {Button} from 'antd'

import {invitesService} from 'services'
import useUserContext from 'components/User/useUserContext'
import TableWithPageHeader from 'components/TableWithPageHeader'
import columns from './columns'

const Customers = () => {
  const {user, setUser} = useUserContext()
  const [interacted, setInteracted] = React.useState(false)
  const [refresh, setRefresh] = React.useState(0)

  const updateUserContext = useCallback(data => {
    setUser(u => ({...u, notificationsCount: data.total}))

    return (
      data.items.map(e => ({
        ...e.owner,
        state: e.state,
        inviteUuid: e.uuid,
        setInteracted: setInteracted,
      }))
    )
  }, [setUser])

  const refreshCall = () => {
    setRefresh(r => r + 1)
    setInteracted(false)
  }

  const RefreshButton = <Button key='refresh' type='primary' onClick={refreshCall}>Refresh</Button>

  return (
    <>
      <TableWithPageHeader
        rowKey='inviteUuid'
        title='Received invites'
        subtitle='Here you can find all your invites'
        columns={columns}
        pagination={interacted ? null : true}
        extra={interacted && RefreshButton}
        service={useCallback(
          page => invitesService.getInvites(user.accountantProfile.uuid, user.accessToken, page),
          [user.accountantProfile.uuid, user.accessToken])}
        dataHandler={updateUserContext}
        refresh={refresh}
      />
      {interacted && <div style={{textAlign: 'right', marginTop: '1em'}}>{RefreshButton}</div>}
    </>
  )
}

export default Customers
